const { actionCreators } = require("react/api/actions/monitor");

Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};
Greenmile.Toolbar.Map.MultiRouteControl = Greenmile.Toolbar.Map.MultiRouteControl || {};

Greenmile.Toolbar.Map.MultiRouteControl = function (selector, map, options) {

  this.toolbar = null;

  this.addListeners = () => {
    if (!selector) {
      return false;
    }

    const button = document.querySelector(`${selector} .btnToggleMultiroute`);

    button.addEventListener('click', () => {
      if (button.classList.contains('selected')) {
        window.globalStore.dispatch(actionCreators.removeAllRoutesFromMap());
        button.classList.remove('selected');
      }
    });
  };
};
